import dayjs from "dayjs";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useDeleteBanner,
  useDisableBanner,
} from "../../../api/banner/use-banner";
import { useBannerById } from "../../../api/banner/use-banner-detail";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import Button from "../../../components/ui/Button/Button";

import Modal from "../../../components/ui/Modal/Modal";
import FieldBox from "../../../utils/Form/ui/FieldBox";

const BannerDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useBannerById(id);
  const { mutate: deleteBanner } = useDeleteBanner();
  const { mutate: disableBanner } = useDisableBanner();
  const bannerData = data?.data;
  const handleEdit = () => {
    navigate("edit");
  };

  const handleBack = () => {
    navigate("/banner-management");
  };

  const handleDelete = async () => {
    await deleteBanner(id);
  };

  const handleDisableBanner = async () => {
    const payload = {
      id: id,
      title: bannerData?.title,
      imagePC: bannerData?.imagePC,
      imageMobile: bannerData?.imageMobile,
      onAt: dayjs.unix(bannerData?.onAt).unix(),
      offAt: dayjs.unix(bannerData?.offAt).unix(),
      location: bannerData?.location,
    };
    if (bannerData?.url === null) {
      await disableBanner({
        ...payload,
        productGroupId: bannerData?.productGroupId,
      });
    } else {
      await disableBanner({
        ...payload,
        url: bannerData?.url,
      });
    }
  };

  return (
    <>
      <div>
        <TitlePage title="배너 관리 > 배너 상세" />
        <div className="mt-4">
          <form>
            <div className="flex items-center">
              <div className="w-1/2">
                <FieldBox splitted label="등록상태">
                  <span className="p-2">
                    {bannerData?.status === "OFF" ? (
                      "사용안함"
                    ) : (
                      <span className="text-[#e80000]">사용중</span>
                    )}
                  </span>
                </FieldBox>
              </div>
              <div className="w-1/2">
                <FieldBox splitted label="등록일시">
                  <span className="p-2">
                    {dayjs(bannerData?.createdAt).format("YYYY-MM-DD hh:mm")}
                  </span>
                </FieldBox>
              </div>
            </div>
            <div className="flex items-center">
              <div className="w-1/2">
                <FieldBox splitted label="사용 시작일">
                  <span className="p-2">
                    {dayjs(bannerData?.onAt).format("YYYY-MM-DD")}
                  </span>
                </FieldBox>
              </div>
              <div className="w-1/2">
                <FieldBox splitted label="사용 종료일">
                  <span
                    className={`p-2 ${
                      bannerData?.status === "ON" ? "text-[#e80000]" : ""
                    }`}
                  >
                    {dayjs(bannerData?.offAt).format("YYYY-MM-DD")}
                  </span>
                </FieldBox>
              </div>
            </div>
            <div className="flex items-center">
              <div className="w-1/2">
                <FieldBox splitted label="배너 위치">
                  <span className="p-2">{bannerData?.location}</span>
                </FieldBox>
              </div>
              <div className="w-1/2">
                <FieldBox splitted label="배너 코드">
                  <span className="p-2">{bannerData?.code || "-"}</span>
                </FieldBox>
              </div>
            </div>

            <FieldBox label="배너 제목">
              <span className="p-2">{bannerData?.title}</span>
            </FieldBox>
            <FieldBox label="배너 이미지">
              <div className="flex flex-wrap items-center p-2 gap-4">
                <div className="relative w-[470px] h-[150px] border border-[#cccccc]">
                  <img
                    src={bannerData?.imagePC}
                    className="object-cover w-full h-full"
                    alt="banner"
                  />
                </div>
                <div className="relative w-[220px] h-[150px] border border-[#cccccc]">
                  <img
                    src={bannerData?.imageMobile}
                    className="object-cover w-full h-full"
                    alt="banner"
                  />
                </div>
              </div>
            </FieldBox>
            <FieldBox label="배너 내부 링크" isLast>
              <div className="px-2 flex gap-4 items-center w-[92%]">
                <input
                  type="text"
                  className="flex-auto border border-[#cccccc] h-9 w-full py-0.5 px-2 outline-none rounded-[4px] bg-[#ededed] text-[#999999]"
                  disabled={true}
                  value={
                    bannerData?.url === null
                      ? bannerData?.productGroup?.name
                      : bannerData?.url
                  }
                />
              </div>
            </FieldBox>
            <div className="flex justify-end mt-4">
              <Button onClick={handleBack} width="w-24" text="목록" />
              <Modal
                maxWidth="max-w-[27rem]"
                description={
                  <span>
                    해당 배너를 사용안함으로 변경하시겠습니까? <br />
                    1. 사용 안함으로 처리되면, ONEDAY Mall 상단 배너에서
                    제외됩니다.
                    <br />
                    2. 배너는 사용 종료일이 경과하면 자동으로 '배너 사용 안함'
                    처리가 됩니다.
                    <br />
                    3. 만약 다시 사용을 할 경우, 수정에서 사용 시작일-사용
                    종료일을 재설정 <br />
                    해주세요.
                  </span>
                }
                onSubmit={handleDisableBanner}
              >
                <Button
                  isDisabled={bannerData?.status === "OFF"}
                  width="w-24"
                  text="배너 사용 안함"
                />
              </Modal>
              <Modal
                submitText="확인"
                description={
                  <span>
                    해당 배너를 삭제하시겠습니까? <br />
                    삭제할 경우, 데이터는 복구되지 않습니다.
                  </span>
                }
                onSubmit={handleDelete}
              >
                <Button width="w-24" text="삭제" />
              </Modal>
              <Button
                onClick={handleEdit}
                type="submit"
                primary
                text="수정"
                width="w-24"
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default BannerDetailPage;
